/* 进度条 */
import NProgress from '@/utils/nprogress';
import store from '@/store/index'
import { Loading, Message, MessageBox } from 'element-ui';
import { defaultSettings } from '@/settings';
// 接口白名单 处理非表单提交的post请求例如带有排序的查询接口用的post请求，但是该请求不需要成功提示及模态框
let whiteList = [
  'yl/login',
  'product/page' //商品列表
];
// 判断url是否属于白名单
const isWhiteList = (url) => {
  return whiteList.some(item => url.includes(item));
}

let loadingInstance;
/**
 * 请求拦截器
 * @param config
 */
export const requestInterceptor = (config) => {
  const userToken = store.getters['user/token'];
  //显示水平进度条
  showProgress(config) && NProgress.start();
  //非get请求，显示加载页面
  if (config.method !== 'get' && !isWhiteList(config.url)) {
    loadingInstance = Loading.service({ lock: true, background: 'rgba(0, 0, 0, 0.7)' });
  }
  //移除空请求参数
  removeEmptyParams(config);
  //设置请求头token
  // userToken && config.headers.set(defaultSettings.token.key, userToken);
  if (userToken) {
    config.headers[defaultSettings.token.key] = userToken;
  }
  return config;
};

/**
 * 移除为空的请求参数
 * @param config
 */
function removeEmptyParams(config) {
  const params = config.params;
  if (params) {
    Object.keys(params).forEach(key => {
      let val = params[key];
      if (typeof val === 'string') {
        val = val.trim();
      }
      if (val === null || val === undefined || val === '') {
        delete params[key];
      }
    });
  }
}

/**
 * 响应拦截器
 * @param res
 */
export const responseInterceptor = (res) => {
  //隐藏水平进度条
  showProgress(res.config) && NProgress.done();
  loadingInstance?.close();

  let resData = res.data;
  if (resData instanceof Blob) {//二进制流响应
    const reader = new FileReader();
    reader.readAsText(resData);
    reader.onload = (result) => {
      try {
        //如果返回的是json错误信息
        resData = JSON.parse(result.target?.result);
        return responseJson(res);
      } catch (error) {
        //真正的二进制文件流
        // handleDownload(resData, res);
        return res;
      }
    };
    return res;
  }
  return responseJson(res);
};

/**
 * 响应json数据
 * @param response
 */
function responseJson(response) {
  const { data: resData, config } = response;
  const { code, message, data, extras } = resData;
  if (code !== 0 && code !== 200) {
    //错误处理
    return handleError({ code, message, config, response });
  }
  handleSuccess(resData, config);

  //判断响应是否携带token信息
  const token = response.headers?.token || extras?.token || data.token;
  token && store.commit('user/SET_TOKEN', token);
  return response||resData;

}

/**
 * 成功后处理
 * @param resData 响应数据
 * @param config 请求配置
 */
function handleSuccess(resData, config) {

  const successHandle = config.meta?.successHandle;
  if (successHandle) {
    successHandle(resData);
    return;
  }
  if (('post' === config.method || 'put' === config.method) && !isWhiteList(config.url)) {
    Message.success('操作成功');
  }
}

/**
 * 是否展示接口请求进度条,默认为true
 * @param config
 * @returns
 */
function showProgress(config) {
  const showProgress = config.meta?.showProgress;
  return showProgress === undefined || showProgress;
}

/**
 * 统一进行错误处理
 * @param error
 * @returns
 */
export const handleError = (error) => {
  const { config } = error;
  showProgress(config) && NProgress.done();
  loadingInstance?.close();
  if (errorHandle(config)) {//全局处理错误
    handleErrorCode(error);
  }
  return Promise.reject(error);//不处理异常错误，调用方处理
};

/**
 * 根据错误码处理异常
 */
let msgBox;

function handleErrorCode(error) {
  if (!error.response) {
    //网络异常
    Message.error(error.message);
    return;
  }
  const { response: { data, status }, config } = error;
  const code = data?.code || status || error.code || error.status;
  const message = data?.message || error.message;
  switch (code) {
    case 4000: //企业未认证
      location.href = "/certification/company"; //跳转到企业认证页面
      break;
    case 401:
      if (msgBox){
        return false;
      }
      if (!msgBox) {
        msgBox = MessageBox.confirm(message, '提示', {
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: '确认',
        });
      }
      store.dispatch('user/removeToken');
      msgBox.then(() => {
        msgBox = null; //重置msgBox
        location.href = '/login'; //跳转到登录页面
      }).catch(() => {
        msgBox = null; //重置msgBox
      })
      break;
    default:
      if (tipMsg(config)) {//弹窗错误消息
        // ElNotification.error({ message });
        Message.error(message);
      }
  }
}

/**
 * 是否全局错误处理
 * @param config
 */
function errorHandle(config) {
  const errorHandle = config.meta?.handleError;
  if (errorHandle === undefined) {
    return true;
  }
  return errorHandle;
}

/**
 * 是否提示错误消息
 * @param config
 */
function tipMsg(config) {
  const tipMsg = config.meta?.tipMsg;
  if (tipMsg === undefined) {
    return true;
  }
  return tipMsg;
}
